export const DiagonalHatch = () => (
    <defs>
        <pattern
            id="diagonalHatch"
            patternUnits="userSpaceOnUse"
            width="6"
            height="6"
        >
            <path d="M0,6 l6,-6" stroke="#333" strokeWidth="1" />
        </pattern>
    </defs>
);
